import * as React from 'react';

const LegacyGetS12nCertBannerWrapper = () => {
  return <div>LegacyGetS12nCertBannerWrapper</div>;
};

export default LegacyGetS12nCertBannerWrapper;
